import _extends from "@babel/runtime/helpers/esm/extends";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _class, _class2, _temp;

import React from 'react';
import { globalObject } from '@skbkontur/global-object';
import { Sticky } from "../../Sticky";
import { isFunction } from "../../../lib/utils";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { responsiveLayout } from "../../ResponsiveLayout/decorator";
import { rootNode } from "../../../lib/rootNode";
import { getDOMRect } from "../../../lib/dom/getDOMRect";
import { ModalSeparator } from "../../Modal/ModalSeparator";
import { isTheme2022 } from "../../../lib/theming/ThemeHelpers";
import { styles } from "../SidePage.styles";
import { SidePageContext } from "../SidePageContext";
import { SidePageCloseButton } from "../SidePageCloseButton";
export var SidePageHeaderDataTids = {
  root: 'SidePageHeader__root',
  close: 'SidePage__close'
};
/**
 * Шапка сайдпейджа
 *
 * @visibleName SidePage.Header
 */

export var SidePageHeader = responsiveLayout(_class = rootNode(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SidePageHeader, _React$Component);

  function SidePageHeader() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.context = _this.context;
    _this.state = {
      isReadyToFix: false
    };
    _this.wrapper = null;
    _this.sticky = null;
    _this.lastRegularHeight = 0;
    _this.closeIcon = /*#__PURE__*/React.createElement(SidePageCloseButton, null);

    _this.componentDidMount = function () {
      globalObject.addEventListener == null ? void 0 : globalObject.addEventListener('scroll', _this.update, true);
      _this.context.setHasHeader == null ? void 0 : _this.context.setHasHeader();

      _this.context.headerRef(_assertThisInitialized(_this));
    };

    _this.componentWillUnmount = function () {
      globalObject.removeEventListener == null ? void 0 : globalObject.removeEventListener('scroll', _this.update, true);
      _this.context.setHasHeader == null ? void 0 : _this.context.setHasHeader(false);

      _this.context.headerRef(null);
    };

    _this.update = function () {
      var _this$sticky;

      (_this$sticky = _this.sticky) == null ? void 0 : _this$sticky.reflow();

      _this.updateReadyToFix();
    };

    _this.renderHeader = function (fixed) {
      var _cx, _cx2;

      if (fixed === void 0) {
        fixed = false;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.header(_this.theme), (_cx = {}, _cx[styles.headerFixed(_this.theme)] = fixed, _cx[styles.mobileHeader(_this.theme)] = _this.isMobileLayout, _cx))
      }, _this.renderClose(fixed), /*#__PURE__*/React.createElement("div", {
        className: cx(styles.title(_this.theme), (_cx2 = {}, _cx2[styles.mobileTitle(_this.theme)] = _this.isMobileLayout, _cx2[styles.titleFixed()] = fixed, _cx2))
      }, isFunction(_this.props.children) ? _this.props.children(fixed) : _this.props.children));
    };

    _this.renderHeader2022 = function (fixed) {
      if (fixed === void 0) {
        fixed = false;
      }

      var isDisplayed = _this.props.hasSeparator || fixed;
      return /*#__PURE__*/React.createElement("div", null, _this.renderHeader(fixed), isDisplayed && /*#__PURE__*/React.createElement(ModalSeparator, {
        fixed: fixed
      }));
    };

    _this.renderClose = function (fixed) {
      var _cx3;

      var stickyOffset = parseInt(_this.theme.sidePageHeaderStickyOffset);
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.wrapperClose(_this.theme), (_cx3 = {}, _cx3[styles.wrapperCloseFixed(_this.theme)] = fixed, _cx3[styles.mobileWrapperClose(_this.theme)] = _this.isMobileLayout, _cx3))
      }, _this.isMobileLayout ? _this.closeIcon : /*#__PURE__*/React.createElement(Sticky, {
        side: "top",
        offset: stickyOffset
      }, _this.closeIcon));
    };

    _this.updateReadyToFix = function () {
      if (_this.wrapper) {
        var wrapperScrolledUp = getDOMRect(_this.wrapper).top;
        var isReadyToFix = _this.regularHeight + wrapperScrolledUp <= _this.fixedHeaderHeight;

        _this.setState(function (state) {
          return state.isReadyToFix !== isReadyToFix ? _extends({}, state, {
            isReadyToFix: isReadyToFix
          }) : state;
        });
      }
    };

    _this.wrapperRef = function (el) {
      _this.wrapper = el;
    };

    _this.stickyRef = function (el) {
      _this.sticky = el;
    };

    return _this;
  }

  var _proto = SidePageHeader.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return _this2.renderMain();
    });
  };

  _proto.getStickyProp = function getStickyProp() {
    if (typeof this.props.sticky !== 'undefined') {
      return this.props.sticky;
    }

    if (this.isMobileLayout) {
      return false;
    }

    return true;
  };

  _proto.renderMain = function renderMain() {
    var isReadyToFix = this.state.isReadyToFix;
    var isStickyDesktop = !this.isMobileLayout && this.getStickyProp() && isReadyToFix;
    var isStickyMobile = this.isMobileLayout && this.getStickyProp();
    var header = isTheme2022(this.theme) ? this.renderHeader2022 : this.renderHeader;
    return /*#__PURE__*/React.createElement(CommonWrapper, _extends({
      rootNodeRef: this.setRootNode
    }, this.props), /*#__PURE__*/React.createElement("div", {
      "data-tid": SidePageHeaderDataTids.root,
      ref: this.wrapperRef,
      className: styles.headerWrapper()
    }, isStickyDesktop || isStickyMobile ? /*#__PURE__*/React.createElement(Sticky, {
      ref: this.stickyRef,
      side: "top"
    }, header) : header()));
  };

  _createClass(SidePageHeader, [{
    key: "regularHeight",
    get: function get() {
      var isReadyToFix = this.state.isReadyToFix;

      if (!this.wrapper) {
        return 0;
      }

      if (!isReadyToFix) {
        this.lastRegularHeight = getDOMRect(this.wrapper).height;
      }

      return this.lastRegularHeight;
    }
  }, {
    key: "fixedHeaderHeight",
    get: function get() {
      var theme = this.theme;
      return parseInt(theme.sidePageHeaderFixedLineHeight) + parseInt(theme.sidePageHeaderFixedPaddingY) * 2;
    }
  }]);

  return SidePageHeader;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'SidePageHeader', _class2.displayName = 'SidePageHeader', _class2.contextType = SidePageContext, _class2.defaultProps = {
  hasSeparator: false
}, _temp)) || _class) || _class;